import { required, minLength, maxLength } from 'vuelidate/lib/validators'

export const validateCategory = {
  form: {
    name: {
      required,
      minLength: minLength(4),
      maxLength: maxLength(64),
    },
    description: {
        required,
        maxLength: maxLength(255)
    },
  },
}
